import { CallsTab } from '@/features/events/components/Detail/Tabs/CallsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/calls')({
  component: CallsTab,
});
